import { compact } from 'lodash-es';
import { stripHtml } from 'client/utils/string-utils';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { OLD_REVIEW_FORMAT_LAST_YEAR } from 'site-modules/shared/constants/editorial-review';
import { getModelSectionMap } from 'site-modules/shared/utils/core-page/editorial-review';

export function getRatingScale(editorialReview) {
  return editorialReview && editorialReview.isTenPointScale ? 10 : 5;
}

export function getOverallRating(editorialReview) {
  return editorialReview?.ratingsV4?.score || editorialReview?.ratings?.overall?.rating;
}

export function getOverallVerdict(editorialReview) {
  return editorialReview?.ratingsV4?.verdict || editorialReview?.ratings?.overall?.text;
}

export function getScorecardRatings({ editorialReview, vehicle, params }) {
  let ratings;
  if (vehicle?.year > OLD_REVIEW_FORMAT_LAST_YEAR) {
    const modelSectionMap = getModelSectionMap({
      edmundsTypeCategories: vehicle?.edmundsTypeCategories,
      params,
      isScorecardV4: editorialReview?.isScorecardV4,
    });

    ratings = modelSectionMap.map(({ key, name }) => ({
      ratingValue: editorialReview?.ratings?.[key]?.rating,
      reviewAspect: name,
      reviewBody: editorialReview?.ratings?.[key]?.text,
    }));
  } else {
    ratings = ['Driving', 'Comfort', 'Interior', 'Utility', 'Technology'].map(section => ({
      ratingValue: editorialReview?.ratings?.[section.toLowerCase()]?.rating,
      reviewAspect: section,
    }));
  }

  return ratings.filter(({ ratingValue }) => ratingValue);
}

export function getPlainReviewBody({ editorialReview, vehicle, params }) {
  const scale = getRatingScale(editorialReview);
  const scorecardRatings = getScorecardRatings({ editorialReview, vehicle, params });

  return stripHtml(
    compact([
      editorialReview?.whatsNew,
      editorialReview?.summary,
      editorialReview?.introduction,
      editorialReview?.summarySnippet,
      editorialReview?.review,
      editorialReview?.body,
      editorialReview?.needToKnowTitle,
      editorialReview?.needToKnow,
      editorialReview?.competitorsTitle,
      editorialReview?.competitors,
      editorialReview?.longTermTitle,
      editorialReview?.longTerm,
      ...scorecardRatings.map(
        ({ ratingValue, reviewAspect, reviewBody }) => `${reviewAspect} (${ratingValue} / ${scale}) - ${reviewBody}`
      ),
      editorialReview?.weRecommendTitle,
      editorialReview?.weRecommend,
      editorialReview?.trimFeaturesTitle,
      editorialReview?.trimFeaturesBodySnippet,
      editorialReview?.trimFeaturesBody,
      editorialReview?.goodCar,
    ]).join(' ')
  );
}

export function getSellCarPageUrl(params = {}) {
  const queryParams = objectToQueryString(params);

  return `/sell-car/${queryParams.length ? '?' : ''}${queryParams}`;
}
